// EmptyButton
import React from 'react';

const EmptyButton = (props) => {
    return (
        <button
            type="button"
            className="emptyButton"
            onClick={props.onClick}
            disabled={props.disabled}
        >
            {props.icon ? props.icon : null}
            <span>{props.text}</span>
        </button>
    );
};

export default EmptyButton;